import { FC } from 'react'
import styled, { css } from 'styled-components'
import useLeftSection from '@app.feature/jobCategory/hooks/useLeftSection'
import LeftBackButton from './LeftBackButton'
import LeftItem from './LeftItem'

interface IFLeftSectionProps {
  className?: string
}

const LeftSection: FC<IFLeftSectionProps> = ({ className }) => {
  const {
    isFirstDepth,
    leftSectionItem,
    getIsActiveId,
    onItemClick,
    onBackButtonClick,
  } = useLeftSection()

  return (
    <StyledWrapper className={className}>
      {leftSectionItem.map((item) => {
        const getClassName = () => {
          if (getIsActiveId(item.id)) {
            return 'active-item'
          }

          if (item.isSelect) {
            return 'select-item'
          }

          return ''
        }

        return (
          <LeftItem
            key={item.id}
            label={item.name}
            onClick={() => {
              onItemClick(item)
            }}
            className={getClassName()}
          />
        )
      })}
      {!isFirstDepth && (
        <LeftBackButton label="대분류 다시 선택" onClick={onBackButtonClick} />
      )}
    </StyledWrapper>
  )
}

export default LeftSection

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.background.bg_3};
    overflow: auto;
    border-right: 1px solid ${theme.line.line_3};

    .active-item {
      background-color: white;
      border-top: 1px solid ${theme.line.line_3};
      border-bottom: 1px solid ${theme.line.line_3};

      .left-label {
        color: ${theme.color.primary_2};
        font-weight: 500;
      }

      .arrow-right {
        color: ${theme.color.text_1};
      }
    }

    .select-item .left-label {
      color: ${theme.color.primary_2};
      font-weight: 500;
    }
  `}
`
